var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49282_2335)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1729 11.9421H9.20631C8.80252 10.9529 7.83344 10.2967 6.76341 10.2967C5.69338 10.2967 4.73439 10.9529 4.32051 11.9421H0.999369C0.444164 11.9421 0 12.3863 0 12.9415C0 13.4967 0.444164 13.9409 0.999369 13.9409H4.32051C4.73439 14.9302 5.69338 15.5863 6.76341 15.5863C7.83344 15.5863 8.79243 14.9302 9.20631 13.9409H14.1729C14.7281 13.9409 15.1722 13.4967 15.1722 12.9415C15.1722 12.3863 14.7281 11.9421 14.1729 11.9421ZM6.76341 13.951C6.2082 13.951 5.75394 13.4967 5.75394 12.9415C5.75394 12.3863 6.2082 11.932 6.76341 11.932C7.31861 11.932 7.77287 12.3863 7.77287 12.9415C7.77287 13.4967 7.31861 13.951 6.76341 13.951Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1729 2.05949H5.91546C5.50158 1.07021 4.54259 0.414062 3.47256 0.414062C2.40252 0.414062 1.44353 1.07021 1.02965 2.05949H0.999369C0.444164 2.05949 0 2.50365 0 3.05886C0 3.61406 0.444164 4.05823 0.999369 4.05823H1.02965C1.44353 5.0475 2.41262 5.70365 3.47256 5.70365C4.53249 5.70365 5.50158 5.0475 5.91546 4.05823H14.183C14.7382 4.05823 15.1823 3.61406 15.1823 3.05886C15.1823 2.50365 14.7281 2.05949 14.1729 2.05949ZM3.47256 4.06832C2.91735 4.06832 2.46309 3.61406 2.46309 3.05886C2.46309 2.50365 2.91735 2.04939 3.47256 2.04939C4.02776 2.04939 4.48202 2.50365 4.48202 3.05886C4.48202 3.61406 4.02776 4.06832 3.47256 4.06832Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3552 5.35034C12.2852 5.35034 11.3262 6.00649 10.9123 6.99577H0.999369C0.444164 6.99577 0 7.43993 0 7.99514C0 8.55034 0.444164 8.9945 0.999369 8.9945H10.9123C11.3161 9.98378 12.2852 10.6399 13.3552 10.6399C14.8189 10.6399 16 9.44876 16 7.99514C16 6.54151 14.8088 5.35034 13.3552 5.35034ZM13.3552 9.01469C12.8 9.01469 12.3457 8.56044 12.3457 8.00523C12.3457 7.45003 12.8 6.99577 13.3552 6.99577C13.9104 6.99577 14.3647 7.45003 14.3647 8.00523C14.3647 8.56044 13.9104 9.01469 13.3552 9.01469Z",
    fill: "#FFFFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49282_2335"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterAlt);
export default __webpack_public_path__ + "static/media/filter-alt.2ded16fb69eb01b6029778c6d40a5eff.svg";
export { ForwardRef as ReactComponent };